import React, { useEffect, useState } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { useParams } from 'react-router-dom';
import { withRouter } from 'react-router';


import JobDetailsCard from './job-details-card.component';
import NoData from '../../no-data/no-data.component';
import {url} from '../../../url';

// styles
import { Skeleton } from '@material-ui/lab';
import { Row, Col } from 'react-bootstrap';

function JobDetail(props) {
    let btns = props.location?.state;
    const { id } = useParams();
    const [job, setJob] = useState();

    const [notAnsweredApp, setnotAnsweredApp] = useState();
    const [shortlistedApp, setshortlistedApp] = useState();
    const [rejectedApp, setRejectedApp] = useState();


    
    const fetch = () => {
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = url;
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;
            next();
        });
        return apolloFetch
    }
    const fetchJobs = () => {
        if (localStorage.jwt) {
            const apolloFetch = fetch();

            let GET_JOB_BY_ID = `query($id : Int!  $is_answered : Boolean $is_accepted : Boolean  $is_done : Boolean){
                jobFindToEmployer(id: $id){
                id
                title
                brif
                job_type{name}
                job_level_of_experience_type{name}
                user{name}
                company{name}
                tags{name}
                questions{title}
                created_at
                updated_at
                ApplicationsGet(Inputs : {
                is_answered : $is_answered,
                is_accepted : $is_accepted,
                is_done : $is_done
              },first : 1000){
                             data{
                                id
                                user{
                                    id
                                    name
                                    profile_image{url}
                                }
                                bio{
                                    speciality{name}
                                    video{url}
                                    created_at
                                }}
              }
            }
            }`
            apolloFetch({
                query: GET_JOB_BY_ID,
                variables: {
                    id: id
                }
            }).then(res => {
                if (res.data.jobFindToEmployer) {
                    setJob(res.data.jobFindToEmployer)
                }
                else {
                    setJob("not found")
                }
            }).catch((err) => console.log(err));
            // get not answered 
            apolloFetch({
                query: GET_JOB_BY_ID,
                variables: {
                    id: id,
                    is_answered : false
                }
            }).then(res => {
                if (res.data.jobFindToEmployer) {
                    setnotAnsweredApp(res.data.jobFindToEmployer)
                }
                else {
                    setnotAnsweredApp("not found")
                }
            }).catch((err) => console.log(err));
            // get shortlisted
            apolloFetch({
                query: GET_JOB_BY_ID,
                variables: {
                    id: id,
                    is_accepted : true
                }
            }).then(res => {
                if (res.data.jobFindToEmployer) {
                    setshortlistedApp(res.data.jobFindToEmployer)
                }
                else {
                    setshortlistedApp("not found")
                }
            }).catch((err) => console.log(err));
            // get rejected
            apolloFetch({
                query: GET_JOB_BY_ID,
                variables: {
                    id: id,
                    is_answered : true,
                    is_accepted : false
                }
            }).then(res => {
                if (res.data.jobFindToEmployer) {
                    setRejectedApp(res.data.jobFindToEmployer)
                }
                else {
                    setRejectedApp("not found")
                }
            }).catch((err) => console.log(err));
        }
    }
    const handleApplicationAnswer = (id, is_accepted, comment) => {
        if (localStorage.jwt) {
            const apolloFetch = fetch();
            //get user data
            apolloFetch({
                query:
                    `mutation($application_id : Int  $is_accepted :Boolean $comment : Text){
                      applicationAnswer(Inputs: {
                        application : {id : $application_id}
                        is_accepted : $is_accepted
                        comment : $comment
                      }){
                        Status{
                          code
                          message
                        }
                        Application{
                          id
                          is_accepted
                          comment
                        }
                      }
                    }`,
                variables: {
                    "application_id": id,
                    "is_accepted": is_accepted,
                    "comment": comment
                }
            }).then(res => {
                fetchJobs();
            }).catch((err) => console.log(err));
        }
    }
    useEffect(function () {
        fetchJobs()
    }, []);
    if (!job) {
        return (
            <>
                <main className="container mt-5 mb-5">
                    <Row>
                        <Col md={8}>
                            <Skeleton variant="rect" height={500} />
                        </Col>
                        <Col md={4}>
                            <Skeleton variant="rect" height={400} />
                        </Col>
                    </Row>
                </main>
            </>
        )
    } else if (job === 'not found') {
        return (
            <React.Fragment key={id}>
                <NoData />
            </React.Fragment>
        )
    }
    else {
        return (
            <React.Fragment key={id}>
                <JobDetailsCard data={job} notAnswered={notAnsweredApp} shortlisted={shortlistedApp} rejected={rejectedApp} callBackFun={handleApplicationAnswer} btnsGroup={btns} />
            </React.Fragment>
        )
    }
}
export default withRouter(JobDetail)